import React from "react";
import { Route, Switch } from "react-router-dom";

import RegistrationTitleBar from "./RegistrationTitleBar";
import Start from "./Start";
import SearchingPage from "./Searching";
import ConfirmPhone from "./ConfirmPhone";
import NotFound from "./NotFound";
import Navigator from "./Navigator";

const Registration = ({ match, onCancel, location, currentRegistration }) => (
  <div className="registration-wizard">
    <RegistrationTitleBar
      onCancel={onCancel}
      location={location}
      currentRegistration={currentRegistration}
    />
    <div className="md-toolbar-relative">
      <Switch>

        {/* TODO: Crappy attempt at making start work both as a step and the default */}
        <Route exact path={"/registration/start"} component={Start} />
        <Route
          exact
          path={"/registration/searching"}
          component={SearchingPage}
        />
        <Route exact path={"/registration/not-found"} component={NotFound} />
        <Route
          exact
          path={"/registration/confirm-phone"}
          component={ConfirmPhone}
        />

        <Route component={Navigator} />

      </Switch>
    </div>
  </div>
);

export default Registration;



// WEBPACK FOOTER //
// ./src/registration/components/RegistrationLayout.jsx